var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 49,
    viewBox: "0 0 63 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_375_5837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.25 17.259C15.2836 17.259 17.75 14.6907 17.75 11.5319C17.75 8.373 15.2836 5.80475 12.25 5.80475C9.21641 5.80475 6.75 8.373 6.75 11.5319C6.75 14.6907 9.21641 17.259 12.25 17.259ZM50.75 17.259C53.7836 17.259 56.25 14.6907 56.25 11.5319C56.25 8.373 53.7836 5.80475 50.75 5.80475C47.7164 5.80475 45.25 8.373 45.25 11.5319C45.25 14.6907 47.7164 17.259 50.75 17.259ZM53.5 20.1225H48C46.4875 20.1225 45.1211 20.7579 44.1242 21.787C47.5875 23.7646 50.0453 27.3351 50.5781 31.5767H56.25C57.7711 31.5767 59 30.2971 59 28.7132V25.8496C59 22.6908 56.5336 20.1225 53.5 20.1225ZM31.5 20.1225C36.8195 20.1225 41.125 15.6393 41.125 10.1001C41.125 4.56089 36.8195 0.0776367 31.5 0.0776367C26.1805 0.0776367 21.875 4.56089 21.875 10.1001C21.875 15.6393 26.1805 20.1225 31.5 20.1225ZM38.1 22.9861H37.3867C35.5992 23.8809 33.6141 24.4179 31.5 24.4179C29.3859 24.4179 27.4094 23.8809 25.6133 22.9861H24.9C19.4344 22.9861 15 27.6036 15 33.2949V35.8721C15 38.2435 16.8477 40.1674 19.125 40.1674H43.875C46.1523 40.1674 48 38.2435 48 35.8721V33.2949C48 27.6036 43.5656 22.9861 38.1 22.9861ZM18.8758 21.787C17.8789 20.7579 16.5125 20.1225 15 20.1225H9.5C6.46641 20.1225 4 22.6908 4 25.8496V28.7132C4 30.2971 5.22891 31.5767 6.75 31.5767H12.4133C12.9547 27.3351 15.4125 23.7646 18.8758 21.787Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_375_5837",
    x: 0,
    y: 0.0776367,
    width: 63,
    height: 48.0898,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_375_5837"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_375_5837",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg4);
export default __webpack_public_path__ + "static/media/img4.024692c5d42ae78edbb0d042356206b7.svg";
export { ForwardRef as ReactComponent };